export class Answer {
  constructor(entity) {
    this.id = entity?.id || Date.now();
    this.title = entity?.title || "";
    this.isCorrectAnswer = entity?.isCorrectAnswer || false;
  }
}
